/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 25/12/2020
 */
import Vue from "@/entry/setupVue3.js"

import QwLinkButton from "@/core/components/Controls/Buttons/QwLinkButton.vue";
import QwButtonDanger from "@/core/components/Controls/Buttons/QwButtonDanger.vue";
import QwButton from "@/core/components/Controls/Buttons/QwButton.vue";
import QwDropdownButton from "@/core/components/Controls/Buttons/QwDropdownButton.vue";
import QwButtonMain from "@/core/components/Controls/Buttons/QwButtonMain.vue";
import QwDrawer from "@/core/components/Form/QwoachDrawer.vue";
import QwTag from "@/core/components/Controls/QwTag.vue";
import QwEmpty from "@/core/components/Controls/QwEmpty.vue";
import QwCheckbox from "@/core/components/Controls/QwCheckbox.vue";
import QwInput from "@/core/components/Controls/QwInput.vue";
import QwInputNumber from "@/core/components/Controls/QwInputNumber.vue";
import QwInputSearch from "@/core/components/Controls/QwInputSearch.vue";
import QwButtonIcon from "@/core/components/Controls/Buttons/QwButtonIcon.vue";
import QwForm from "@/core/components/Controls/QwForm.vue";
import QwCollapseItem from "@/core/components/Controls/QwCollapseItem.vue";
import QwCollapse from "@/core/components/Controls/QwCollapse.vue";
import QwRadio from "@/core/components/Controls/QwRadio.vue";
import QwRadioGroup from "@/core/components/Controls/QwRadioGroup.vue";
import QwSwitch from "@/core/components/Controls/QwSwitch.vue";
import QwSelect from "@/core/components/Controls/QwSelect.vue";
import QwSteps from "@/core/components/Controls/steps/QwSteps.vue";
import QwStep from "@/core/components/Controls/steps/QwStep.vue";
import QwLink from "@/core/components/QwLink.vue";
import QwColorPicker from "@/core/components/Controls/QwColorPicker.vue";
import QwImageUploader from "@/core/components/Controls/QwImageUploader/QwImageUploader.vue";
import QwImg from "@/core/components/view/QwImg.vue";
import QwAutocompleteExtended from "@/core/components/Controls/QwAutocompleteExtended.vue";
import QwAutocomplete from "@/core/components/Controls/QwAutocomplete.vue";
import QwDatePicker from "@/core/components/Controls/QwDatePicker.vue";
import QwDropdown from "@/core/components/Controls/Buttons/QwDropdown.vue";
import QwSlider from "@/core/components/Controls/QwSlider.vue";
import ToolWorkSubmitAction from "@/core/modules/coach/Resources/CoachingTools/GenericTools/runtime/ToolWorkSubmitAction.vue";

Vue.component('qw-button', QwButton)
Vue.component('qw-link-button', QwLinkButton)
Vue.component('qw-button-danger', QwButtonDanger)
Vue.component('qw-drawer', QwDrawer)
Vue.component('qw-tag', QwTag)
Vue.component('qw-empty', QwEmpty)
Vue.component('qw-button-main', QwButtonMain)
Vue.component('qw-dropdown-button', QwDropdownButton)
Vue.component('qw-dropdown', QwDropdown)
Vue.component('qw-checkbox', QwCheckbox)
Vue.component('qw-input', QwInput)
Vue.component('qw-input-number', QwInputNumber)
Vue.component('qw-input-search', QwInputSearch)
Vue.component('qw-button-icon', QwButtonIcon)
Vue.component('qw-form', QwForm)
Vue.component('qw-collapse', QwCollapse)
Vue.component('qw-collapse-item', QwCollapseItem)
Vue.component('qw-radio', QwRadio)
Vue.component('qw-radio-group', QwRadioGroup)
Vue.component('qw-switch', QwSwitch)
Vue.component('qw-select', QwSelect)
Vue.component('qw-steps', QwSteps)
Vue.component('qw-step', QwStep)
Vue.component('qw-link', QwLink)
Vue.component('qw-color-picker', QwColorPicker)
Vue.component('qw-image-uploader', QwImageUploader)
Vue.component('qw-slider', QwSlider)
Vue.component('tool-work-submit-action', ToolWorkSubmitAction)


Vue.component('qw-img', QwImg)
// Vue.component('qw-button-email', QwButtonEmail)// we don't include this component in the global components because it has heavy dependencies NotificationHelper that leaks tiptap into the global scope. Import locally where needed
Vue.component('qw-autocomplete-extended', QwAutocompleteExtended)
Vue.component('qw-autocomplete', QwAutocomplete)

Vue.component('qw-date-picker', QwDatePicker)


// Vue.component('v-style', {
// 	render: function (createElement) {
// 		return createElement('style', this.$slots.default)
// 	}
// });
